import React from 'react';
import { Button, Badge } from '../../ui';

const TestKeywordsDialog = ({
  isOpen,
  onClose,
  testMessage,
  setTestMessage,
  testResults,
  onTestKeyword,
  keywordTab
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onClose}></div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
              Test Keywords
            </h3>
            <p className="text-sm text-gray-500 mb-4">
              Enter a message to test against your keywords. This helps you verify that your keywords will match the messages you're interested in.
            </p>
            
            <div className="mb-4">
              <label htmlFor="test-message" className="block text-sm font-medium text-gray-700 mb-1">
                Test Message
              </label>
              <textarea
                id="test-message"
                rows={4}
                className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                value={testMessage}
                onChange={(e) => setTestMessage(e.target.value)}
              ></textarea>
            </div>
            
            {testResults && (
              <div className="mt-4">
                <h4 className="text-sm font-medium text-gray-900 mb-2">
                  Test Results:
                </h4>
                
                {testResults.hasMatch ? (
                  <div className="bg-green-50 border border-green-200 rounded-md p-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <p className="text-sm font-medium text-green-800">
                          <strong>Match found!</strong> The message contains the following keywords:
                        </p>
                        <div className="mt-2 flex flex-wrap gap-1">
                          {testResults.matches && Array.isArray(testResults.matches) && testResults.matches.map((keyword, index) => (
                            <Badge key={index} variant="green" size="sm">{String(keyword || '').toLowerCase()}</Badge>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <p className="text-sm font-medium text-yellow-800">
                          No matches found. The message doesn't contain any of your keywords.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <Button
              variant="primary"
              onClick={() => onTestKeyword(keywordTab)}
              disabled={!testMessage.trim()}
              className="sm:ml-3"
            >
              Test
            </Button>
            <Button
              variant="secondary"
              onClick={onClose}
              className="mt-3 sm:mt-0"
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestKeywordsDialog;
